import React from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { diamondSvg } from "../../svg";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var StepThree = function StepThree() {
  var history = useHistory();
  var handleClick = function handleClick() {
    history.push("/deals");
  };
  var handleEnquiry = function handleEnquiry() {
    history.push("/myprofile/enquiries");
  };
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx("div", {
      className: "flex items-center justify-center mx-auto pl-6 lg:p-0 my-5 lg:m-0 ",
      children: /*#__PURE__*/_jsxs("div", {
        className: "text-center ",
        children: [/*#__PURE__*/_jsx("div", {
          className: "flex justify-center mb-2",
          children: diamondSvg
        }), /*#__PURE__*/_jsx("h1", {
          className: "font-bold text-lg md:text-xl ",
          children: "Thank You "
        }), /*#__PURE__*/_jsx("p", {
          className: "font-semibold  text-sm md:text-base my-2 ",
          children: "For Your Enquiry!"
        }), /*#__PURE__*/_jsxs("p", {
          className: " text-sm text-[#adadad]",
          children: ["You can manage your Enquires from ", /*#__PURE__*/_jsx("br", {}), " ", /*#__PURE__*/_jsx("span", {
            className: "text-primary font-semibold cursor-pointer",
            onClick: handleEnquiry,
            children: "My Enquires"
          }), " ", "section under my profile"]
        }), /*#__PURE__*/_jsxs("div", {
          className: "flex  text-primary justify-center my-2 items-center gap-1 cursor-pointer",
          onClick: handleClick,
          children: [/*#__PURE__*/_jsx("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "8.414",
            height: "14.828",
            viewBox: "0 0 8.414 14.828",
            children: /*#__PURE__*/_jsx("path", {
              id: "_8666777_chevron_right_arrow_icon",
              "data-name": "8666777_chevron_right_arrow_icon",
              d: "M15,18,9,12l6-6",
              transform: "translate(-8 -4.586)",
              fill: "none",
              stroke: "#15519e",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2"
            })
          }), /*#__PURE__*/_jsx("button", {
            className: "text-primary text-sm md:text-base my-2",
            children: "Back to Deals"
          })]
        })]
      })
    })
  });
};
export default StepThree;